import { Component } from '@angular/core';
import { Output, EventEmitter, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent {
  @Input() display = false;
  @Output() selecteddisplayevent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() okEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ClosePopup() {
    this.display = false;
    this.closeEvent.emit(this.display);
  }

  OkPopupclick() {
    this.display = false;
    this.okEvent.emit(this.display);
  }
}
